// extracted by mini-css-extract-plugin
export default {"wrapper":"SupplierEnquiryForm_wrapper__m+fUl"};